import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, FormControl, FormGroup, Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { hideModal, removeModal } from "../../../redux/ducks/modals";
import { URL } from '../../../config'
import { postRequest } from '../../../utils/httpRequest'

class DenyReason extends Component {
  constructor(props) {
    super(props);

    this.state = { denyValue: "" }
  }
  setDenyValue = (evt) => {
    this.setState({ denyValue: evt.target.value });
  }
  handleDenyClick = () => {
    const props = this.props;
    const url = `${URL.user}/denyaccess`;
    const userToken = props.oidc.user.access_token;
    postRequest(url, { reason: this.state.denyValue }, userToken).then(() => {
      props.handleRemoveModal();
    });
  }
  render() {
    const {
      show,
      handleHideModal,
      handleRemoveModal,
    } = this.props;

    const handleDenyClick = this.handleDenyClick;
    const setDenyValue = this.setDenyValue;

    return (
      <Modal
        show={show}
        onHide={handleHideModal}
        onExited={handleRemoveModal}
        backdropClassName="modal-backdrop">
        <form>
          <Modal.Header closeButton>
            <Modal.Title>Deny Registration Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className="form-horizontal">
              <FormGroup>
                <label className="col-sm-1 col-lg-1 control-label">Reason</label>{'    '}
                <Col sm={11} md={11}>
                  <FormControl type="text" name="lastname" id="lastname" className="form-control" onChange={setDenyValue} />
                </Col>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleHideModal} bsStyle="default">
              Cancel
        </Button>
            <Button bsStyle="danger" onClick={handleDenyClick}>Deny Request</Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

DenyReason.propTypes = {
  show: PropTypes.bool,
  handleHideModal: PropTypes.func,
  handleRemoveModal: PropTypes.func
};

const mapStateToProps = state => ({
  oidc: { ...state.oidc }
});

const mapDispatchToProps = dispatch => ({
  handleHideModal: () => {
    dispatch(hideModal("DENY_REASON"));
  },
  handleRemoveModal: () => {
    dispatch(removeModal("DENY_REASON"));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DenyReason);



// WEBPACK FOOTER //
// ./src/containers/user/modals/denyreason-container.js